import { Trans } from '@lingui/react';
import { useCompanyId } from '@startuptools/common/react-wrapper';
import { Stack } from '@startuptools/ui/Stack';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Typography } from '@startuptools/ui/Typography';
import { PowerOfAttorney } from '../../../common/components/documents/PowerOfAttorney';
import { usePowerOfAttorneysSuspenseQuery } from './PowerOfAttorneys.graphql';
import { ErrorDisplay } from '../../../../components/error-display/ErrorDisplay';
import { useStepper } from '../../../../components/steppers/common/StepperContext';
import { useStepperStepContent } from '../../../../components/steppers/common/StepperStepContentContext';
import { GqlMeeting } from '../../../../graphql/base-types.graphql';

export const GMStepPowerOfAttorneys = ({ meeting }: { meeting: Pick<GqlMeeting, 'id'> }) => {
  const companyId = useCompanyId();
  const { stepNext } = useStepper();
  const { validatorStatus } = useStepperStepContent();

  const {
    data: { meetingParticipants },
  } = usePowerOfAttorneysSuspenseQuery({
    variables: { companyId, meetingId: meeting.id, filter: { isShareholder: true, hasProxy: true } },
  });

  return (
    <Stack gap={3}>
      <Typography level="h4">
        <Trans id="Power of Attorneys" />
      </Typography>

      <Stack gap={2}>
        {meetingParticipants.models.map(mp => (
          <PowerOfAttorney key={mp.id} meetingParticipant={mp} />
        ))}
      </Stack>

      {validatorStatus?.hasError && <ErrorDisplay error={validatorStatus.error} />}

      <Box>
        <Button onClick={() => stepNext()}>
          <Trans id="Continue" />
        </Button>
      </Box>
    </Stack>
  );
};
